import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import InputError from 'modules/_shared/components/InputError';

import { SelectorOption } from 'types';
import { FixedShare } from '../types/Share';
import ShareEncumbranceViewFormAvailableRanges from './ShareEncumbranceViewFormAvailableRanges';
import {
  encumbranceOptions,
  EncumbranceTypes,
} from '../constants/encumbranceOptions';

type Props = {
  share: FixedShare;
  encumbranceName: EncumbranceTypes;
  encumbranceNameOption: SelectorOption | null;
  encumbranceDate: string;
  encumbranceFrom: number;
  encumbranceTo: number;
  // eslint-disable-next-line no-unused-vars
  handleChangeEncumbranceName: (event: any) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEncumbranceDate: (event: any) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEncumbranceFrom: (event: any) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEncumbranceTo: (event: any) => void;
  isValidRange: boolean;
  validRanges: any[];
  handleClickRange: (range: any) => void; // eslint-disable-line
};

const ShareEncumbranceViewFormEncumbranceData: FC<Props> = ({
  share,
  encumbranceName,
  encumbranceNameOption,
  encumbranceDate,
  encumbranceFrom,
  encumbranceTo,
  handleChangeEncumbranceName,
  handleChangeEncumbranceDate,
  handleChangeEncumbranceFrom,
  handleChangeEncumbranceTo,
  isValidRange,
  validRanges,
  handleClickRange,
}) => {
  const { t } = useTranslate();

  const animatedComponents = makeAnimated();

  const encumbranceSelectOptions: SelectorOption[] = encumbranceOptions.map(
    (option) => ({
      value: option.value,
      label: t(`ShareEncumbranceOption_${option.label}`) || option.label,
    })
  );

  return (
    <>
      <div className="col-6">
        <div className="form-group">
          <label className="form-label" htmlFor="encumbrance-name">
            {t('EncumbranceType')}
            {!encumbranceName && <span className="text-danger"> *</span>}
          </label>

          <Select
            id="encumbrance-name"
            value={encumbranceNameOption}
            closeMenuOnSelect
            className="react-select"
            // @ts-ignore
            options={encumbranceSelectOptions}
            components={animatedComponents}
            placeholder={t('SelectEncumbrance')}
            onChange={handleChangeEncumbranceName}
            isMulti={false}
          />
        </div>
      </div>

      <div className="col-6">
        <div className="form-group">
          <label className="form-label" htmlFor="encumbrance-date">
            {t('EncumbranceDate')}
            {!encumbranceDate && <span className="text-danger"> *</span>}
          </label>

          <div className="form-control-wrap">
            <input
              type="date"
              id="encumbrance-date"
              className="form-control form-control-md"
              value={encumbranceDate}
              onChange={handleChangeEncumbranceDate}
            />
          </div>
        </div>
      </div>

      <div className="col-6">
        <div className="row mb-2">
          <div className="col-6">
            <div className="form-group">
              <label className="form-label" htmlFor="encumbrance-from">
                {t('From')}
              </label>

              <div className="form-control-wrap">
                <input
                  type="number"
                  id="encumbrance-from"
                  min={share?.from}
                  className="form-control form-control-md"
                  value={encumbranceFrom}
                  onChange={handleChangeEncumbranceFrom}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label className="form-label" htmlFor="encumbrance-to">
                {t('To')}
              </label>

              <div className="form-control-wrap">
                <input
                  type="number"
                  max={share?.to}
                  id="encumbrance-to"
                  className="form-control form-control-md"
                  value={encumbranceTo}
                  onChange={handleChangeEncumbranceTo}
                />
              </div>
            </div>
          </div>
        </div>

        {!isValidRange && <InputError errorMessage="InvalidRange" />}

        <ShareEncumbranceViewFormAvailableRanges
          validRanges={validRanges}
          handleClickRange={handleClickRange}
        />
      </div>
    </>
  );
};

export default ShareEncumbranceViewFormEncumbranceData;
